import { BoxProps } from '@mantine/core'

import { SpotlightCommunityWithPostsSession } from 'interfaces/types'

import { Item } from './item'
import SectionWrapper from '../sectionWrapper'

type Props = {
  applyH1?: boolean
} & SpotlightCommunityWithPostsSession &
  BoxProps

const EmbedPost = (props: Props) => {
  const {
    styles,
    className,
    classNames,
    applyH1,
    mobileBanner,
    desktopBanner,
    postDetail: post,
    wrapperProps,
    ...boxProps
  } = props

  return post ? (
    <SectionWrapper.Wrapper
      defaultColor={'#fff'}
      {...wrapperProps}
      {...boxProps}
    >
      <Item
        applyH1={applyH1}
        post={post}
        mobileBanner={mobileBanner}
        desktopBanner={desktopBanner}
      />
    </SectionWrapper.Wrapper>
  ) : null
}

export { EmbedPost }
